import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate'

// bs
import auth from "./auth.module";
import user from "./user.module";
import weekDay from "./week-day.module";
// import bm from "./bm.module";
//import services from "./services.module";
import profile from "./profile.module";
import persons from "./persons.module";
// import schedule from "./schedule.module";
// client module
import category from "./category.module";
import benefits from "./benefit.module";
import employees from "./employees.module";
import clients from "./clients.module";
import beautySpots from "./beautyspots.module";
import appUser from "./appuser.module";
import bs_finance from "@/store/bs_finance.module"; 
import bm_finance from "@/store/bm_finance.module"; 

import { CHANGE_PROGRESS, CHRANGE_SNACK } from "./mutations/mutations.type";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    inProgress: false,
    snackbar: {
      timeout: 9000,
      color: "",
      snackbar: false,
      text: ""
    },
    confirmDialog: {
      dialog: false,
      title: "",
      text: "",
      evento: () => {}
    }
  },
  getters: {
    inProgress: state => {
      return state.inProgress;
    },
    snackbar: state => {
      return state.snackbar;
    },
    confirmDialog: state => {
      return state.confirmDialog;
    }
  },
  mutations: {
    [CHANGE_PROGRESS](state, opt) {
      state.inProgress = opt;
    },
    [CHRANGE_SNACK](state, snack) {
      state.snackbar = snack;
    }
  },
  modules: {
    auth,
    user,
    //bm,
    weekDay,
    profile,
    persons,
    //schedule,
    // client modules
    category,
    benefits,
    employees,
    // bonder
    clients,
    beautySpots,
    appUser,
    bs_finance,
    bm_finance
  },
  plugins: [
    createPersistedState({
        paths: [
          'auth',
          'user',
          //bm,
          'weekDay',
          'profile',
          'persons',
          //schedule,
          // client modules
          'category',
          'benefits',
          'employees',
          // bonder
          'clients',
          'beautySpots',
          'appUser',
          'bs_finance',
          'bm_finance'
        ]
    })
  ]
});
